<template>
  <div class="pa-3">
    <v-card-title
      class="align-self-center secondary--text text-h6 text-md-subtitle-1 font-weight-bold"
    >
      {{ repereEconomique.libelleFamilleGraine }}
    </v-card-title>

    <div class="d-flex justify-space-between">
      <div class="intro fixed-width-libelle align-self-center" />
      <div class="intro fixed-width align-self-center align-center">
        min
      </div>
      <div class="intro fixed-width align-self-center align-center">
        défaut
      </div>
      <div class="intro fixed-width align-self-center align-center">
        max
      </div>
      <v-spacer />
      <div class="align-self-center" />
    </div>

    <div class="d-flex justify-space-between">
      <div class="intro fixed-width-libelle align-self-center">
        Rendement
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.rendement.minimum != null ? repereEconomique.rendement.minimum : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.rendement.valeurParDefaut != null ? repereEconomique.rendement.valeurParDefaut : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.rendement.maximum != null ? repereEconomique.rendement.maximum : '-' }}
      </div>
      <v-spacer />
      <AgrButton
        class="align-self-center"
        icon
        @click="onEditModalUpdateParametre('Rendement', repereEconomique.rendement)"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
    </div>
    <div class="d-flex justify-space-between">
      <div class="intro fixed-width-libelle align-self-center">
        Charges semences
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesSemences.minimum != null ? repereEconomique.chargesSemences.minimum : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesSemences.valeurParDefaut != null ? repereEconomique.chargesSemences.valeurParDefaut : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesSemences.maximum != null ? repereEconomique.chargesSemences.maximum : '-' }}
      </div>
      <v-spacer />
      <AgrButton
        class="align-self-center"
        icon
        @click="onEditModalUpdateParametre('Charges semences', repereEconomique.chargesSemences)"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
    </div>
    <div class="d-flex justify-space-between">
      <div class="intro fixed-width-libelle align-self-center">
        Charges engrais
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesEngrais.minimum != null ? repereEconomique.chargesEngrais.minimum : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesEngrais.valeurParDefaut != null ? repereEconomique.chargesEngrais.valeurParDefaut : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesEngrais.maximum != null ? repereEconomique.chargesEngrais.maximum : '-' }}
      </div>
      <v-spacer />
      <AgrButton
        class="align-self-center"
        icon
        @click="onEditModalUpdateParametre('Charges engrais', repereEconomique.chargesEngrais)"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
    </div>
    <div class="d-flex justify-space-between">
      <div class="intro fixed-width-libelle align-self-center">
        Charges phyto
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesPhyto.minimum != null ? repereEconomique.chargesPhyto.minimum : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesPhyto.valeurParDefaut != null ? repereEconomique.chargesPhyto.valeurParDefaut : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesPhyto.maximum != null ? repereEconomique.chargesPhyto.maximum : '-' }}
      </div>
      <v-spacer />
      <AgrButton
        class="align-self-center"
        icon
        @click="onEditModalUpdateParametre('Charges phyto', repereEconomique.chargesPhyto)"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
    </div>
    <div class="d-flex justify-space-between">
      <div class="intro fixed-width-libelle align-self-center">
        Charges fixes
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesFixes.minimum != null ? repereEconomique.chargesFixes.minimum : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesFixes.valeurParDefaut != null ? repereEconomique.chargesFixes.valeurParDefaut : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.chargesFixes.maximum != null ? repereEconomique.chargesFixes.maximum : '-' }}
      </div>
      <v-spacer />
      <AgrButton
        class="align-self-center"
        icon
        @click="onEditModalUpdateParametre('Charges fixes', repereEconomique.chargesFixes)"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
    </div>
    <div class="d-flex justify-space-between">
      <div class="intro fixed-width-libelle align-self-center">
        Rémunération
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.remuneration.minimum != null ? repereEconomique.remuneration.minimum : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.remuneration.valeurParDefaut != null ? repereEconomique.remuneration.valeurParDefaut : '-' }}
      </div>
      <div class="titre-h4 fixed-width align-self-center secondary--text align-center">
        {{ repereEconomique.remuneration.maximum != null ? repereEconomique.remuneration.maximum : '-' }}
      </div>
      <v-spacer />
      <AgrButton
        class="align-self-center"
        icon
        @click="onEditModalUpdateParametre('Rémunération', repereEconomique.remuneration)"
      >
        <v-icon color="grey darken-2">
          mdi-pencil-outline
        </v-icon>
      </AgrButton>
    </div>
  </div>
</template>

<script>
import { AgrButton } from '@agrial/ui'

export default {
  name: 'CarteSimulateurEco',
  components: { AgrButton },
  props: {
    repereEconomique: {
      type: Object,
      default: () => { }
    },
  },

  methods: {
    onEditModalUpdateParametre (libelleCritere, parametre) {
      this.$emit('onEdit', {parametre: parametre, libelleCritere:libelleCritere, libelleFamilleGraine:this.repereEconomique.libelleFamilleGraine})
    }
  }
}
</script>

<style lang="scss" scoped>
  .fixed-width-libelle {
    width:160px;
  }
  .fixed-width {
    width: 60px;
  }
</style>
